import { createSlice } from '@reduxjs/toolkit'

let newState

const collectionSlice = createSlice({
  name: 'galaktikaCollection',
  initialState: {
    isLoading: false,
    collections: {},
    status: 'NOT_FETCHED',
  },
  reducers: {
    getCollection() {},
    setCollection(state, action) {
      switch (action.payload.type) {
        case 'GET_COLLECTION':
          newState = {
            ...state,
            isLoading: true,
            status: 'GET_COLLECTION',
            error: '',
          }
          return newState
        case 'FETCHING_SUCCESS':
          newState = {
            ...state,
            isLoading: false,
            status: 'FETCHING_SUCCESS',
            collections: action.payload.collections,
            fullNFTCollection: action.payload.fullNFTCollection,
            error: '',
          }
          return newState
        // case "USER_COLLECTION_FETCHED":
        //   newState = {
        //     ...state,
        //     isLoading: true,
        //     status: "USER_COLLECTION_FETCHED",
        //     collections: action.payload.collections,
        //     error: "",
        //   };
        // return newState;
        case 'FETCHING_ERROR':
          newState = {
            ...state,
            isLoading: false,
            status: 'FETCHING_ERROR',
            error: action.payload.error,
          }
          return newState
        case 'FETCHING_CANCELLED':
          newState = {
            ...state,
            isLoading: false,
            status: 'FETCHING_CANCELLED',
          }
          return newState
        default:
          break
      }
    },
  },
})

export const { getCollection, setCollection } = collectionSlice.actions

export default collectionSlice.reducer
